import React, { FunctionComponent } from 'react';
import Styled from './Pill.styled';

export type PillType =
  | 'success'
  | 'warning'
  | 'info'
  | 'danger'
  | 'primary'
  | 'brown'
  | 'purple'
  | 'withdrawn'
  | 'graduated'
  | 'draff';

export interface PillProps {
  text: string;
  type: PillType;
}

export const Pill: FunctionComponent<PillProps> = ({ text, type }) => (
  <Styled className={type}>{text}</Styled>
);
